// frontend/packages/business-console/src/services/homeFeedService.js
//
// Thin wrapper over GET /api/v2/home/feed — the mobile Home task-feed
// aggregator (docs/design/mobile-console-ux.md §5). Business context is
// supplied via the x-business-id header (axios interceptor in
// @upryzze/services), so callers don't pass businessId.

import { api } from '@upryzze/services';

/**
 * GET /api/v2/home/feed
 * @returns {Promise<{ items: Array<{
 *   type: string, id: string, href: string, title: string,
 *   subtitle: string, amountCents: number|null, ts: string|null,
 *   actionLabel: string
 * }>, generatedAt: string, degraded?: boolean }>}
 */
export async function getHomeFeed() {
  const { data } = await api.get('/v2/home/feed');
  return data || { items: [] };
}
